import React, { type FC, type ReactNode } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Paper, type SxProps, type Theme, Typography } from '@mui/material'

import { Translation } from '../../../domain'

import { Button } from '../common'
import { FormattedTranslation, useTranslator } from '../Internationalization'
import { useSelectedLog, useSelectedLogDispatcher } from './State'

const itemStyle: SxProps<Theme> = { p: 2, wordBreak: 'break-all' }

const Item: FC<Readonly<{ primary: Translation, secondary: ReactNode }>> = ({ primary, secondary }) => (
    <>
        <Grid container sx={itemStyle}>
            <Grid size={{ xs: 2 }}>
                <Typography variant="body2">
                    <FormattedTranslation id={primary} />
                </Typography>
            </Grid>
            <Grid size={{ xs: 10 }}>
                <Typography variant="body2">{secondary}</Typography>
            </Grid>
        </Grid>
        <Divider />
    </>
)

export const Modal: FC = () => {
    const selectLog = useSelectedLogDispatcher()
    const log = useSelectedLog()
    const translator = useTranslator()

    if (log === null) {
        return null
    }

    const close: VoidFunction = () => selectLog(null)

    return (
        <Dialog
            data-testid="log-details-modal"
            maxWidth="lg"
            fullWidth
            open
            aria-labelledby={translator.formatTranslation(Translation.LOG_DETAILS)}
            onClose={close}
        >
            <DialogTitle variant="subtitle1">{translator.formatTranslation(Translation.LOG_DETAILS)}</DialogTitle>
            <DialogContent>
                <Paper>
                    <Item primary={Translation.TIME} secondary={log.timestamp.getTime()} />
                    {log.pid && <Item primary={Translation.PID} secondary={log.pid} />}
                    {log.hostname && <Item primary={Translation.HOSTNAME} secondary={log.hostname} />}
                    {log.className && <Item primary={Translation.CLASS_NAME} secondary={log.className} />}
                    <Item primary={Translation.MESSAGE} secondary={log.message} />
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button variant="secondary" onClick={close}>
                    {translator.formatTranslation(Translation.CLOSE)}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
